import Http from '../Http'
import { IQuery } from '../interfaces/Query'
import { IToken } from '../interfaces/Token'
import { Routes } from '../routes'

export default class StockLocationArea extends Http {
  public async show(token: IToken, params: IQuery = {}): Promise<any> {
    return (await this.spreeResponse(
      'get',
      Routes.stockLocationAreasPath(),
      token,
      params,
    )) as any
  }
}
